"use client";

import { useEffect, useState, ReactNode } from "react";
import { createPortal } from "react-dom";
import { HeaderSlotsContext, useHeaderSlots } from "./header-slots";

export function HeaderSlotsProvider({ children }: { children: ReactNode }) {
  const [titleSlot, setTitleSlot] = useState<HTMLElement | null>(null);
  const [actionsSlot, setActionsSlot] = useState<HTMLElement | null>(null);
  const [registered, setRegistered] = useState(0);

  return (
    <HeaderSlotsContext.Provider value={{ titleSlot, actionsSlot, setTitleSlot, setActionsSlot, registered, setRegistered }}>
      {children}
    </HeaderSlotsContext.Provider>
  );
}

/**
 * Renders a page's title, description and action buttons inside the floating
 * header. Pages keep their own state and handlers; the JSX is just portaled.
 */
export default function PageHeader({ title, description, children }: {
  title: string; description?: string; children?: ReactNode;
}) {
  const { titleSlot, actionsSlot, setRegistered } = useHeaderSlots();

  useEffect(() => {
    setRegistered((n) => n + 1);
    return () => setRegistered((n) => n - 1);
  }, [setRegistered]);

  return (
    <>
      {titleSlot &&
        createPortal(
          <div className="min-w-0">
            <h1 className="text-base font-semibold text-gray-900 truncate leading-tight">{title}</h1>
            {description && <p className="text-xs text-gray-500 truncate">{description}</p>}
          </div>,
          titleSlot
        )}
      {actionsSlot && children && createPortal(children, actionsSlot)}
    </>
  );
}
